import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'app-team-matcher',
  standalone: true,
  templateUrl: './team-matcher.component.html',
  styleUrls: ['./team-matcher.component.scss'],
  imports: [
    DropdownModule,
    TableModule,
    CommonModule,
    FormsModule,
    CheckboxModule,
    ProgressSpinner,
  ],
})
export class TeamMatcherComponent implements OnInit {
  selectedTeam: any = null;
  teams: any[] = [];
  matchData: any = null;
  skills: string[] = [];
  users: string[] = [];
  userImages: { [key: string]: string } = {};
  showLike: boolean = true;
  showTeachingLearning: boolean = true;
  showUsersWithKnowledgeZero: boolean = true;
  userToTeam: { [acronym: string]: number } = {};
  filteredUserList: any[] = []; // <-- rinominato
  loading: boolean = false;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loading = true;
    this.apiService.getAllTeams().subscribe({
      next: (allTeams: any[]) => {
        this.teams = allTeams
          .filter(teamObj => teamObj.active)
          .map(teamObj => ({
            ...teamObj,
            label: teamObj.name,
            value: teamObj.id,
          }));

        this.userToTeam = {};
        for (const team of allTeams) {
          if (team.members) {
            team.members
              .split(',')
              .map((m: string) => m.trim().toLowerCase())
              .forEach((acronym: string) => {
                this.userToTeam[acronym] = team.id;
              });
          }
        }
        console.log('userToTeam mapping:', this.userToTeam);
        this.loading = false;
      },
      error: err => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  searchMatches(teamId: number) {
    this.loading = true;
    this.apiService.getTeamMatches(teamId).subscribe({
      next: (response: any) => {
        const data = Array.isArray(response)
          ? response
          : response.data || response.results || [];
        this.matchData = { data };
        this.skills = Array.from(
          new Set(data.map((row: { skill_name: any }) => row.skill_name))
        );
        this.users = Array.from(
          new Set(data.map((row: { user_name: any }) => row.user_name))
        );

        this.onShowUsersWithKnowledgeZeroChange();
        this.loading = false;
      },
      error: err => {
        console.error(err);
        this.loading = false;
      },
    });
  }

  // Restituisce la riga corrispondente a skill e user
  getRow(skill: string, acronym: string) {
    return this.matchData.data.find(
      (row: any) => row.skill_name === skill && row.acronym === acronym
    );
  }

  getIcon(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const icons: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      like: {
        '1': 'fa-check',
        '2': 'fa-xmark',
        '3': 'fa-minus',
      },
      teaching_learning: {
        '0': 'fa-person-chalkboard',
        '1': 'fa-graduation-cap',
        '2': 'fa-minus',
      },
    };

    return icons[category]?.[String(value)] || 'fa-solid fa-minus';
  }

  getColor(
    category: 'knowledge' | 'like' | 'teaching_learning',
    value: number | null
  ): string {
    const colors: Record<
      'knowledge' | 'like' | 'teaching_learning',
      Record<string, string>
    > = {
      knowledge: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      like: {
        '1': 'p-badge-success',
        '2': 'p-badge-error',
        '3': 'p-badge-undefined',
      },
      teaching_learning: {
        '0': 'p-badge-info',
        '1': 'p-badge-info',
        '2': 'p-badge-undefined',
      },
    };

    return colors[category]?.[String(value)] || 'p-badge-undefined';
  }

  get filteredUsers(): any[] {
    // Adatta la logica se serve filtrare
    return this.filteredUserList;
  }

  onShowUsersWithKnowledgeZeroChange(): void {
    if (this.showUsersWithKnowledgeZero) {
      // Mostra tutti gli utenti (acronym unici)
      this.filteredUserList = Array.from(
        new Map(
          this.matchData.data.map((item: any) => [
            item.acronym,
            { acronym: item.acronym },
          ])
        ).values()
      );
    } else {
      // Mostra solo utenti che NON hanno NESSUN item con knowledge = 2
      const usersWithKnowledge2 = new Set(
        this.matchData.data
          .filter((item: any) => item.knowledge === 2)
          .map((item: any) => item.acronym)
      );

      const allAcronyms = Array.from(
        new Map(
          this.matchData.data.map((item: any) => [
            item.acronym,
            { acronym: item.acronym },
          ])
        ).values()
      );

      this.filteredUserList = allAcronyms.filter(
        (user: any) => !usersWithKnowledge2.has(user.acronym)
      );
    }
  }

  get selectedTeamMembers(): Set<string> {
    if (!this.selectedTeam?.members) {
      alert('selectedTeam.members è undefined o vuoto');
      return new Set();
    }
    const members = this.selectedTeam.members
      .split(',')
      .map((m: string) => m.trim().toLowerCase())
      .filter(Boolean);
    return new Set(members);
  }
}
